module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Bold.7d84776.otf";